import { render, staticRenderFns } from "./UnreadMessageCountComponent.vue?vue&type=template&id=0e386c46&"
import script from "./UnreadMessageCountComponent.vue?vue&type=script&lang=js&"
export * from "./UnreadMessageCountComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports